var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-606 6588)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(606 -6588)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye-solid",
    d: "M21.868,70.776A12.25,12.25,0,0,0,11,64,12.252,12.252,0,0,0,.133,70.776a1.236,1.236,0,0,0,0,1.115A12.25,12.25,0,0,0,11,78.667a12.252,12.252,0,0,0,10.867-6.776,1.236,1.236,0,0,0,0-1.115ZM11,76.833a5.5,5.5,0,1,1,5.5-5.5A5.5,5.5,0,0,1,11,76.833Zm0-9.167a3.64,3.64,0,0,0-.967.145,1.828,1.828,0,0,1-2.555,2.555A3.658,3.658,0,1,0,11,67.667Z",
    transform: "translate(606.999 -6647.333)",
    fill: "#202020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSolid);
export default __webpack_public_path__ + "static/media/eye-solid.cd6675283256ebd8be8e4673105b3476.svg";
export { ForwardRef as ReactComponent };